import { History } from 'history';
import { parse } from 'qs';

import { LocalStorage } from 'src/app/helpers/storage';

export function onSortByChanges(history: History, storage: LocalStorage<string>) {
  return (value: string) => {
    history.push({
      pathname: history.location.pathname,
      search: '?sortBy=' + value
    });
    storage.setItem(value);
  };
}

export function parseSortByParams(search: string, storageValue: string | null): string {
  const { sortBy } = parse(search.replace(/\?/g, ''));
  return sortBy || storageValue || 'NEWEST';
}
